import RfiCategoryDrawer from './RfiCategoryDrawer.component';

export default RfiCategoryDrawer;
